export default __webpack_public_path__ + "static/media/high-throughput-screening-solution.3a3d8a7f.png";